"use client";

import { Sparkles } from "lucide-react";

import IconTile from "@/components/ui/icon-tile";

// Each suggestion gets its own colour, in turn, so the list reads as separate
// choices rather than one block.
const HUES = ["pink", "emerald", "action", "violet", "warning"];

/**
 * "How can I help you?": the suggested questions above the composer, before
 * the person has asked anything, where the eye already is when typing. Each
 * is a string or `{ label, prompt }`; picking one sends it.
 */
export default function AIChatSuggestedPrompts({ prompts, disabled, onPick }) {
  const options = (prompts || [])
    .map((option) => {
      const label =
        typeof option === "string" ? option : option?.label || option?.prompt || "";
      const prompt =
        typeof option === "string" ? option : option?.prompt || option?.label || "";
      return label && prompt ? { label, prompt } : null;
    })
    .filter(Boolean);
  if (!options.length) return null;

  return (
    <div className="px-5 pb-1 pt-3">
      <p className="text-sm font-semibold text-gray-900">How can I help you?</p>
      <ul className="mt-1.5">
        {options.map(({ label, prompt }, index) => (
          <li key={`${label}-${index}`}>
            <button
              type="button"
              onClick={() => onPick(prompt)}
              disabled={disabled}
              data-testid="ai-chat-suggested-prompt"
              className="-mx-2 flex w-[calc(100%+1rem)] items-center gap-2.5 rounded-lg px-2 py-1.5 text-left text-sm text-gray-700 transition-colors hover:bg-stone-200/50 hover:text-gray-900 disabled:opacity-50"
            >
              <IconTile icon={Sparkles} size="xs" hue={HUES[index % HUES.length]} />
              <span className="min-w-0 flex-1">{label}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
